var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3284_2578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99609 15.3896C12.4479 15.3896 15.2461 12.5914 15.2461 9.13965C15.2461 5.68787 12.4479 2.88965 8.99609 2.88965C5.54431 2.88965 2.74609 5.68787 2.74609 9.13965C2.74609 12.5914 5.54431 15.3896 8.99609 15.3896Z",
    stroke: "#5D616F",
    strokeWidth: 1.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.416 13.5596L17.7465 17.89",
    stroke: "#5D616F",
    strokeWidth: 1.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3284_2578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.246094 0.389648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a0d54288b4bc8ff64a34076141909e17.svg";
export { ForwardRef as ReactComponent };